<template>
	<div class="row contentblock" data-aos="fade-in" data-aos-duration="1500" data-aos-once="true">
		<div class="columns column6 image-block">
			<picture>
				<source :srcset="imageWebp" type="image/webp" />
				<source :srcset="image" />
				<img :src="image" :alt="imageAlt" loading="lazy" />
			</picture>
		</div>
		<div class="columns column6 content-block">
			<div class="contentblock-content">
				<h3>{{ header }}</h3>
				<div v-parse-links v-html="content" />
			</div>
		</div>
	</div>
</template>

<script setup>
defineProps({
	image: { type: String, default: '' },
	imageWebp: { type: String, default: '' },
	imageAlt: { type: String, default: '' },
	header: { type: String, default: '' },
	content: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.contentblock {
	display: flex;
	flex-flow: row-reverse wrap;
	align-items: center;
	padding: 0;

	.content-block {
		background: var(--secondary-background-color);
		margin: 40px 0;
	}

	.image-block {
		padding: 0;
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		box-shadow: 0 24px 24px rgb(0 0 0 / 15%);

		img {
			object-fit: cover;
			width: 100%;
			height: 100%;
		}
	}

	&:nth-child(odd) {
		flex-direction: row;

		.image-block {
			left: auto;
			right: 0;
		}
	}

	.contentblock-content {
		padding: 70px 60px;
	}
}

@media (max-width: 1080px) {
	.contentblock {
		.column6 {
			width: 100%;
		}

		.content-block {
			margin: 0 auto 40px;
		}

		.image-block {
			position: relative;
			top: unset;
			left: unset;
			right: unset;
			bottom: unset;
		}
	}
}

@media (max-width: 580px) {
	.contentblock {
		margin-bottom: 25px;

		.contentblock-content {
			padding-left: 20px;
			padding-right: 20px;
		}
	}
}
</style>
